import { consultantSharedStyles } from '../shared/styles';
import { adminPagesSharedStyles, createAdminPageStyles } from '../style';

export const useStyles = createAdminPageStyles({
  ...consultantSharedStyles,
  page: {
    ...adminPagesSharedStyles.page,
    background: '#EDEEF2',
  },
  title: {
    ...adminPagesSharedStyles.title,
    marginBottom: 32,
  },
  body: {
    flex: 1,
    width: '50%',
    '@media (max-width: 900px)': {
      width: '100%',
    },
  },
});
